export const FRAME_NAMES = {
  number: "number",
  cvv: "cvv",
  date: "date",
};

export const MAIN_FRAME = "card";

export const TOKENIZE_ACTION = "tokenize";
export const CHECK_CVV_ACTION = "checkCvv";

export const FOCUS_FIELD_ACTION = "focusField";
export const CLEAR_FIELD_ACTION = "clearField";
export const REVALIDATE_FIELD = "revalidateField";
export const STYLE_FIELD_ACTION = "styleField";
export const SET_PLACEHOLDERS_ACTION = "setPlaceholders";
export const SET_CARD_SCHEME_ACTION = "setCardScheme";
